module.exports = __webpack_public_path__ + "img/cpf.9f251af0.svg";